export const colors = {
  white: "#fff",
  blue: "#0044ba",
  black: "#000",
};
